webpackJsonp([17,18],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(18);

__webpack_require__(21);

__webpack_require__(22);

__webpack_require__(55);

__webpack_require__(15);

var _setupCommonJS = __webpack_require__(16);

var _setupCommonJS2 = _interopRequireDefault(_setupCommonJS);

var _generateThemeBlock = __webpack_require__(234);

var _generateThemeBlock2 = _interopRequireDefault(_generateThemeBlock);

var _themeList = __webpack_require__(229);

var _themeList2 = _interopRequireDefault(_themeList);

var _urlParser = __webpack_require__(9);

var _urlParser2 = _interopRequireDefault(_urlParser);

var _hideLoadingImage = __webpack_require__(14);

var _hideLoadingImage2 = _interopRequireDefault(_hideLoadingImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _setupCommonJS2.default)();

if (_urlParser2.default.branch === 'hualien') {
	(0, _themeList2.default)().then(function (json) {
		var blockHtml = '';
		_jquery2.default.each(json.themes, function (index, theme) {
			blockHtml += (0, _generateThemeBlock2.default)(theme);
		});
		(0, _jquery2.default)('.section-block > .content').prepend(blockHtml);
	}).then(function () {
		(0, _hideLoadingImage2.default)();
	});
} else {
	(0, _hideLoadingImage2.default)();
}

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _appConfig = __webpack_require__(2);

var themeList = function themeList() {
	return fetch(_appConfig.apiUri + '/theme').then(function (res) {
		return res.json();
	}).catch(function (err) {
		return console.error(err);
	});
};

exports.default = themeList;

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _appConfig = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateThemeBlock = function generateThemeBlock(theme) {
	var template = (0, _jquery2.default)('._template-block > .image-block').clone();
	template.find('.title').text(theme.title);
	template.attr('href', 'themes/' + theme.id);
	template.attr('style', 'background-image: url(' + _appConfig.uploadUri + '/' + theme.cover + ')');

	return template.prop('outerHTML');
};

exports.default = generateThemeBlock;

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(4);
__webpack_require__(5);
module.exports = __webpack_require__(199);


/***/ }),

/***/ 55:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[476]);


// WEBPACK FOOTER //
// themes.5b51c7be980d1.js